/**
 * 付款方式代碼對應顯示名稱（SSOT）
 * 後端／綠界可能回傳 Credit 或 Credit_CreditCard，皆顯示為「信用卡」
 */
export const PAYMENT_METHOD_LABELS = {
    Credit: '信用卡',
    Credit_CreditCard: '信用卡',
    ATM: 'ATM 轉帳',
    CVS: '超商代碼',
    BARCODE: '條碼',
    ApplePay: 'Apple Pay',
    LinePay: 'LINE Pay',
    TWQR: 'TWQR',
    twqr: 'TWQR',
    GooglePay: 'Google Pay',
    line_pay: 'LINE Pay',
    linepay: 'LINE Pay',
    ecpay: '綠界',
    cash: '現金',
    cvs_cod: '超商貨到付款',
    pickup_pay: '面交付款',
    pay_on_pickup: '面交付款',
};
/**
 * 依代碼取得付款方式顯示名稱，無對照時回傳原值
 * 先依原 key 查詢，再依小寫查詢（確保 twqr 等顯示為 TWQR）
 */
export function getPaymentMethodLabel(code) {
    if (code == null || !String(code).trim())
        return '-';
    const key = String(code).trim();
    return (PAYMENT_METHOD_LABELS[key] ??
        PAYMENT_METHOD_LABELS[key.toLowerCase()] ??
        key);
}
